import React, { useState, useEffect } from 'react'
import { toast } from 'react-hot-toast';
import { FaPlus } from 'react-icons/fa';
import { fetchUserByIdApi, getUserApi, updateUserApi } from '../../../../Api/user';
import { UserForm } from '../../../../common/components/UserForm';
import SideModal from '../../../general/Sidemodal';

type UserInterface = {
    id: string;
    name: string;
    email: string;
    mobile: string;
    gender: number | null;
    address: string;
    roleType: string;
};
export interface EmployeeInterface {
    id: string;
    userId: string;
    employeeType: string;
    permanentAddress: string;
    isActive: boolean;
    salary: number;
    hourlyRate: number;
    joiningDate: string;
    leavingDate?: string | null;
}

interface Props {
    url: string;
    selectedUser?: UserInterface | null;
    setSelectedUser?: React.Dispatch<React.SetStateAction<UserInterface | null>>;
    searchUserName?: string;
    setSearchUserName?: React.Dispatch<React.SetStateAction<string>>;
    permanentAddress?: string;
    setEmployee: React.Dispatch<React.SetStateAction<EmployeeInterface | null>>;
}

const User = ({ url, selectedUser, setSelectedUser, searchUserName, setSearchUserName, permanentAddress, setEmployee }: Props) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchUserResults, setSearchUserResults] = useState<any[]>([]);
    const [UserLoader, setUserLoader] = useState<boolean>(false);

    const fetchUserData = async (searchTerm: string) => {
        try {
            const response = await getUserApi(searchTerm, url);
            setSearchUserResults(response);
        } catch (error) {
            toast.error("Not Able To Fetch user name");
        }
    };

    useEffect(() => {
        // console.log("searchUserName", searchUserName);
        if (!searchUserName.trim()) {
            setSearchUserResults([]);
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            fetchUserData(searchUserName);
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchUserName]);

    const handleUserSelection = async (value: string) => {
        const selectedUser = searchUserResults.find((user) => user.id === value);
        console.log("selectedUser", selectedUser);

        if (selectedUser) {
            setSearchUserName(selectedUser.name);
            setSelectedUser(null);

            try {
                const userResponse = await fetchUserByIdApi(url, selectedUser.id);
                setSelectedUser(userResponse); // Set the new user's data
                setIsDropdownOpen(false);
            } catch (error) {
                toast.error("Failed to fetch user details. Please try again.");
            }
        } else {
            toast.error("No user found for the selected value.");
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setSelectedUser((prev) => {
            if (!prev) return null; // Ensure `selectedUser` is not null
            return {
                ...prev,
                [name]: name === "Gender" ? (value === "" ? null : parseInt(value)) : value, // Handle Gender as a number
            };
        });
    };

    async function HandleUserEditClick(event: React.FormEvent<HTMLFormElement>): Promise<void> {
        event.preventDefault();
        if (!selectedUser) {
            toast.error("No user selected to edit.");
            return;
        }

        setUserLoader(true);
        try {
            await updateUserApi(
                url,
                selectedUser.id,
                selectedUser.name,
                selectedUser.email,
                selectedUser.mobile,
                selectedUser.address,
                selectedUser.roleType,
                selectedUser.gender
            );
            toast.success("User updated successfully");

        } catch (error) {
            toast.error("An error occurred while updating user details.");
        } finally {
            setUserLoader(false);
        }
    }

    // Use a modal instead of direct navigation for "Add User"
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleNavigation = (event: React.MouseEvent, _url: string) => {
        event.preventDefault();
        setIsModalOpen(true);
    };



    return (
        <div>
            <div className="">
                <div className="relative">
                    <label className="text-gray-900 dark:text-gray-200 font-semibold">
                        Select User
                    </label>
                    <input
                        type="text"
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Type to search user..."
                        value={searchUserName}
                        onChange={(e) => {
                            setSearchUserName(e.target.value);
                            setIsDropdownOpen(true);
                        }}
                    />
                    {/* Dropdown list */}
                    {isDropdownOpen && (
                        <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto bg-white shadow-lg rounded-md border border-gray-300">
                            {searchUserName && searchUserResults.length > 0
                                ? searchUserResults.map((user) => (
                                    <div
                                        key={user.name}
                                        className="py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
                                        onClick={() => handleUserSelection(user.id)}
                                    >
                                        Name: {user.name}, Email: {user.email}, MobileNo: {user.mobile}
                                    </div>
                                ))
                                : searchUserName && (
                                    <div className="py-2 px-3 text-gray-500">
                                        No data found
                                    </div>
                                )}
                        </div>
                    )}
                </div>
                {searchUserName && searchUserResults.length == 0 &&
                    <div className="flex justify-start  md:justify-start mt-14">
                        <button
                            type="button"
                            onClick={(event) => handleNavigation(event, "/admin/users/userform")}
                            className="flex items-center justify-center px-6 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                        >
                            <FaPlus className="font-medium mr-2" />
                            Add User
                        </button>
                    </div>
                }
                {selectedUser && (
                    <div className="relative">
                        {UserLoader && (
                            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                                <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                            </div>
                        )}

                        <form
                            onSubmit={HandleUserEditClick}
                            className={`${UserLoader ? "filter blur-[1px] pointer-events-none" : ""}`}
                        >
                            <div className="mt-4 p-4 border border-gray-300 rounded-md bg-gray-50">
                                <h2 className="text-2xl font-semibold mb-3">
                                    Basic Info
                                </h2>
                                <div className='grid my-4 md:grid-cols-2 gap-4'>
                                    {/* Name */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">
                                            Name <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            required
                                            name="name"
                                            value={selectedUser.name}
                                            onChange={handleInputChange}
                                            type="text"
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                            placeholder="Enter User Name"
                                        />
                                    </div>

                                    {/* Email */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Email</label>
                                        <input
                                            required
                                            name="email"
                                            value={selectedUser.email}
                                            onChange={handleInputChange}
                                            type="email"
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                            placeholder="Enter Email"
                                        />
                                    </div>

                                    {/* Mobile */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Mobile Number</label>
                                        <input
                                            required
                                            name="mobile"
                                            value={selectedUser.mobile}
                                            onChange={handleInputChange}
                                            type="number"
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                            placeholder="Enter Mobile Number"
                                        />
                                    </div>

                                    {/* Gender */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Gender</label>
                                        <select
                                            required
                                            name="gender"
                                            value={selectedUser.gender ?? ""}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                        >
                                            <option value="">Select a Gender</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </select>
                                    </div>

                                    {/*Current Address */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Current Address</label>
                                        <input
                                            required
                                            name="address"
                                            value={selectedUser.address}
                                            onChange={handleInputChange}
                                            type="text"
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                            placeholder="Address"
                                        />
                                    </div>

                                    {/*Permanent Address */}
                                    <div className="flex flex-col space-y-2 w-full">
                                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Permanent Address</label>
                                        <input
                                            required
                                            name="address"
                                            value={permanentAddress ?? ""}
                                            onChange={(e) => setEmployee((prev) => ({ ...prev, permanentAddress: e.target.value }))}
                                            type="text"
                                            className="w-full px-4 py-2 mt-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring focus:ring-blue-300 focus:outline-none"
                                            placeholder="Address"
                                        />
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="flex flex-wrap items-center justify-start gap-2">
                                    <button
                                        type="submit"
                                        className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
            </div>


            <SideModal isOpen={isModalOpen} onClose={() => {
                setIsModalOpen(false);
            }}>
                <UserForm url={url} userId={''} onClose={() => {
                    setIsModalOpen(false);
                }} />
            </SideModal>

        </div>
    )
}

export default User